import { render } from "./download-info.vue?vue&type=template&id=ac2ee0dc&ts=true"
import script from "./download-info.vue?vue&type=script&lang=ts"
export * from "./download-info.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__